import React from 'react';

export default function DragDropZone(props) {
	// console.log('DragDropZone', props);
	return (
		<div className="DragDropZone my-5">
			<div className="text-center my-5 mx-4">
				<i className="fa fa-upload fa-2x" aria-hidden="true" />
				<p className="instructions mt-2 mx-auto w-75">
					{I18n.t('admin.drag_drop_instructions')}
				</p>
			</div>
		</div>
	);
}
